import { ICustomField } from "./interfaces";
import { ICustomFieldsState } from "./reducer";

export interface IWithCustomFieldsState {
  entities: {
    customFields: ICustomFieldsState;
  };
}

export function selectCustomFields(state: IWithCustomFieldsState): ICustomFieldsState {
  return state.entities.customFields;
}

export function selectCustomFieldsList(state: IWithCustomFieldsState): ICustomField[] {
  return Object.values(selectCustomFields(state));
}

export function selectActiveCustomFieldsList(state: IWithCustomFieldsState): ICustomField[] {
  return selectCustomFieldsList(state).filter(({ status }) => status === "active");
}

export function selectCustomFieldById(
  state: IWithCustomFieldsState,
  id: string
): ICustomField | Record<string, unknown> {
  return selectCustomFields(state)[id] || {};
}
